var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 315,
  height: 315,
  preserveAspectRatio: "xMidYMid",
  style: {
    shapeRendering: "auto",
    display: "block",
    background: "#fff"
  },
  viewBox: "0 0 100 100"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-1.6666666666666665s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(30 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-1.5151515151515151s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(60 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-1.3636363636363635s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-1.212121212121212s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-1.0606060606060606s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(150 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.9090909090909091s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.7575757575757576s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(210 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.606060606060606s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.45454545454545453s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.303030303030303s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(300 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.1515151515151515s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 12,
  x: 47,
  y: 24,
  fill: "#033b6c",
  rx: 3,
  ry: 6,
  transform: "rotate(330 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0s",
  dur: "1.8181818181818181s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  values: "1;0"
}))));
export { SvgSpinner as ReactComponent };
export default "data:image/svg+xml;base64,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";